module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "main-section",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "content-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "return-policy-section": "",
      "ma-0": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Return Policy")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.return_policy),
      expression: "user.return_policy"
    }],
    staticClass: "policy-area",
    style: ({
      height: _vm.textAreaHeight
    }),
    attrs: {
      "placeholder": "Write a return policy...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.user.return_policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "return_policy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isSaveAllMode) ? _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.saveReturnPolicy()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "return-policy-section": "",
      "ma-0": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Shipping Policy")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.shipping_policy),
      expression: "user.shipping_policy"
    }],
    staticClass: "policy-area",
    style: ({
      height: _vm.textAreaHeight
    }),
    attrs: {
      "placeholder": "Write a shipping policy...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.user.shipping_policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "shipping_policy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isSaveAllMode) ? _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.saveShippingPolicy()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "return-policy-section": "",
      "ma-0": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Size Chart")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.size_chart),
      expression: "user.size_chart"
    }],
    staticClass: "policy-area",
    style: ({
      height: _vm.textAreaHeight
    }),
    attrs: {
      "placeholder": "Write a size chart...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.user.size_chart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "size_chart", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isSaveAllMode) ? _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.saveSizeChart()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "return-policy-section": "",
      "ma-0": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.privacy_policy),
      expression: "user.privacy_policy"
    }],
    staticClass: "policy-area",
    style: ({
      height: _vm.textAreaHeight
    }),
    attrs: {
      "placeholder": "Write a privacy policy...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.user.privacy_policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "privacy_policy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isSaveAllMode) ? _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.savePrivacyPolicy()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74438020","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/components/policy_tab.vue
// module id = 1777
// module chunks = 180